<div id="email-tagfield-dropdown" class="form-control p-0">
  @for (email of Emails; track email; let index = $index) {
    <span class="badge bg-primary mx-1" contenteditable="false" tabindex="-1">
      {{ email }}
      <i
        class="bi bi-x-lg cursor-select"
        (click)="removeEmail(email, index)"
      ></i>
    </span>
  }
  <div
    #emailEditDiv
    (blur)="blurAddEmail()"
    (keydown)="addEmail($event)"
    (input)="emailChange($event)"
    class="dropdown-toggle-override form-control border-hidden box-shadow-hidden"
    contenteditable="true"
  ></div>
</div>
